import { CURRENCIES } from './matrixClassification';

/**
 * Provide the list of supported currencies.
 *
 * Currently returns the hard-coded CURRENCIES constant from matrixClassification.
 *
 * ## API Integration (Requirement 9)
 *
 * When the backend implements Requirement 9, a GET /currencies endpoint
 * will return the supported currencies:
 *
 * ```json
 * [
 *   { "id": "UNIT", "symbol": "", "label": "Units (no currency)" },
 *   { "id": "NOK", "symbol": "kr", "label": "Norwegian Krone (NOK)" },
 *   { "id": "EUR", "symbol": "€", "label": "Euro (EUR)" }
 * ]
 * ```
 *
 * To integrate:
 * 1. Replace the return with a useQuery call to GET /currencies
 * 2. Use CURRENCIES as initialData / fallback while the query loads
 * 3. Return the query data (same shape: array of {id, symbol, label})
 *
 * Example:
 * ```js
 * import { useQuery } from '@tanstack/react-query';
 * import { api } from '@utils/api';
 *
 * export default function useCurrencies() {
 *   const { data } = useQuery({
 *     queryKey: ['currencies'],
 *     queryFn: () => api.get('/currencies').then(r => r.data),
 *     initialData: CURRENCIES,
 *     staleTime: Infinity, // currencies rarely change
 *   });
 *   return data;
 * }
 * ```
 *
 * @returns {Array<{id: string, symbol: string, label: string}>}
 */
export default function useCurrencies() {
	// TODO: Replace with useQuery call when backend ships Requirement 9
	return CURRENCIES;
}
